import { render, staticRenderFns } from "./ChangeEmailView.vue?vue&type=template&id=88d58cc0&"
import script from "./ChangeEmailView.vue?vue&type=script&lang=ts&"
export * from "./ChangeEmailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports